import WpaCodeParameterInjector from './wpacode/wpacode-parameter-injector';
import WpaCode from './wpacode/wpacode';
import $ from 'jquery';


const wpacode = WpaCode.getCurrent();

$(() => {
   if (wpacode instanceof WpaCode) {
      const paramInjector = new WpaCodeParameterInjector(wpacode);

      setInterval(() => {
         paramInjector.findLinksAndInject();
      }, 1000);
   }
});